<!-- 社区活动次数统计柱状图 -->
<template>
    <div class="nodataBox" v-if="nodata">暂无数据</div>
    <div :id="'echart5'+index" style="width:100%;height:100%" v-else></div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import echarts from 'echarts'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            nodata:false,
        };
    },
  props:{
    index:{
      type:null,
      default:0,
    },
    token:{
      type:String,
      default: ''
    }
  },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        //communityEnrollNum
        getData(){
            //var url = this.urlobj.communityEnrollNum
            var url = this.urlobj.activitySignCount
             this.$get(url,{},{
               token:this.token || this.$store.state.access_token
             }).then(res => {
                 if(res.isSucceed){
                    if(res.rows[0].series.length == 2 && res.rows[0].series[0].data[0] ==0 && res.rows[0].series[1].data[0] ==0){
                        this.nodata = true;
                        return
                    }
                    let data = {
                         xaxis:res.rows[0].xaxis.length>8?res.rows[0].xaxis.slice(0,8):res.rows[0].xaxis,
                         series:res.rows[0].xaxis.length>8?res.rows[0].series.slice(0,16):res.rows[0].series,
                     }
                     //计算markpoint的横坐标位置
                     let markPoint_X = data.series[0].data[0]>data.series[1].data[0]?data.series[0].data[0]:data.series[1].data[0]
                     data.markPointBm= []
                     data.markPointQd= []
                     data.Qd = data.series.filter(item=>item.name=="签到").map(item=>item.data[0]).reverse()
                     data.Bm = data.series.filter(item=>item.name=="报名").map(item=>item.data[0]).reverse()
                     data.Bm.forEach((item,index)=>{
                       data.markPointBm.push({ value:item,xAxis:markPoint_X,yAxis:index})
                     })
                     data.Qd.forEach((item,index)=>{
                       data.markPointQd.push({ value:item,xAxis:markPoint_X,yAxis:index})
                     })
                   if (!this.token) {
                     this.initEcharts(data)
                   }else {
                     this.initCongtaiEcharts(data)
                   }
                 }
            }).catch(e => {
               console.log(e)
            })
        },
        initEcharts (ecdata) {
            console.log(ecdata)
            var id = 'echart5' + this.index
            var echart = echarts.init(document.getElementById(id));
            let option={
                tooltip : {
                    trigger: 'item',
                    axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                        type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow' | 'none' | 'cross'
                    },
                },
                color:['#ff7d7d','#ffc700'],
                legend: {
                    data:['签到','报名'],
                    textStyle:{    //图例文字的样式
                            color:'#91b1fc',  //文字颜色
                            fontSize:12
                        },
                    itemHeight:10,
                    itemWidth:10,
                },
                grid: {
                    left: 15,
                    right: 100,
                    bottom: '3%',
                    top:30,
                    containLabel: true
                },
                xAxis : [
                    {
                        type : 'value',
                        show : false,
                        splitLine:{show: false},//去除网格线
                    }
                ],
                yAxis : [

                    {
                        type : 'category',
                        data:ecdata.xaxis.reverse(),
                        axisLabel:{
                            color:'#b0b0b0',
                            fontSize:12
                        },
                        splitLine:{show: false},//去除网格线
                    }
                ],
                series : [
                    {
                        name:'签到',
                        type:'bar',
                        data:ecdata.Qd,
                        barWidth:5,
                        label:{
                            show:false,
                            // position:'right',
                            // distance:10,
                            // color:'#b0b0b0',  //文字颜色
                            // fontSize:10,
                            // formatter: function (item) {
                            //     return item.data + '% '+ecdata.dypersonTime[item.dataIndex]
                            // },
                        },
                         markPoint:{
                            symbol:'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkM3NDZGNDJEODJCMzExRTlBMjUyQzg4RTkzODREOEI5IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkM3NDZGNDJFODJCMzExRTlBMjUyQzg4RTkzODREOEI5Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6Qzc0NkY0MkI4MkIzMTFFOUEyNTJDODhFOTM4NEQ4QjkiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6Qzc0NkY0MkM4MkIzMTFFOUEyNTJDODhFOTM4NEQ4QjkiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5nN+RvAAAAF0lEQVR42mL8//8/AzpgYsACKBQECDAANlADByyfnVcAAAAASUVORK5CYII=',
                            symbolOffset:['100%',0],
                            data:ecdata.markPointQd,
                            label:{
                                color:'#b0b0b0',  //文字颜色
                                fontSize:10,
                            }
                        }
                    },
                    {
                        name:'报名',
                        type:'bar',
                        data:ecdata.Bm,
                        barWidth:5,
                        barGap:1,
                        label:{
                            show:false,
                        },
                        markPoint:{
                            symbol:'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkM3NDZGNDJEODJCMzExRTlBMjUyQzg4RTkzODREOEI5IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkM3NDZGNDJFODJCMzExRTlBMjUyQzg4RTkzODREOEI5Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6Qzc0NkY0MkI4MkIzMTFFOUEyNTJDODhFOTM4NEQ4QjkiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6Qzc0NkY0MkM4MkIzMTFFOUEyNTJDODhFOTM4NEQ4QjkiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5nN+RvAAAAF0lEQVR42mL8//8/AzpgYsACKBQECDAANlADByyfnVcAAAAASUVORK5CYII=',
                            symbolOffset:['100%',3],
                            data:ecdata.markPointBm,
                            label:{
                                color:'#b0b0b0',  //文字颜色
                                fontSize:10,
                            }
                        }
                    },


                ]
            }
            echart.setOption(option)
        },
      initCongtaiEcharts (ecdata) {
          console.log(ecdata)
        var id = 'echart5' + this.index
        var echart = echarts.init(document.getElementById(id));
        let option={
          tooltip : {
            trigger: 'item',
            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
              type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow' | 'none' | 'cross'
            },
          },
          color:['#ff7d7d','#ffc700'],
          legend: {
            data:['签到','报名'],
            textStyle:{    //图例文字的样式
              color:'#91b1fc',  //文字颜色
              fontSize:16
            },
            itemHeight:10,
            itemWidth:10,
            icon:'rect',
          },
          grid: {
            left: 15,
            right: 100,
            bottom: '3%',
            top:30,
            containLabel: true
          },
          xAxis : [
            {
              type : 'value',
              show : false,
              splitLine:{show: false},//去除网格线
            }
          ],
          yAxis : [

            {
              type : 'category',
              data:ecdata.xaxis.reverse(),
              axisLabel:{
                color:'#b0b0b0',
                fontSize:16
              },
              splitLine:{show: false},//去除网格线
              axisLine:{
                lineStyle:{
                  color:'#283071'
                }
              },
              axisTick:{
                show:false,
              }
            }
          ],
          series : [
            {
              name:'签到',
              type:'bar',
              data:ecdata.Qd.slice(0,5),
              barWidth:7,
              barGap:'45%',
              label:{
                show:true,
                formatter:'{c}',
                color:'#b0b0b0',
                position: ['100%',0],
                padding:[0,0,0,5]
              },
            },
            {
              name:'报名',
              type:'bar',
              data:ecdata.Bm.slice(0,5),
              barWidth:7,
              label:{
                show:true,
                formatter:'{c}',
                color:'#b0b0b0',
                position: ['100%',0],
                padding:[0,0,0,5]
              },
            },
          ]
        }
        echart.setOption(option)
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getData()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
    function handleX(list1,list2) {
      var max = 0
      list1.forEach(item => {
        if (item >max) max = item
      })
      list2.forEach(item => {
        if (item >max) max = item
      })
      console.log([max,0])
      return [max,0]
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.nodataBox{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #b0b0b0;
    height: 100%;
}
</style>
